
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();


export const getInspectionHistory = async (contactId) => {
   
    let url = `${config.API_BASE_URL}/attendeeinspectionhistory/${contactId}`;

    const response = await authenticatedFetch(url, {
        method: 'GET',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error getting inspection history`);
      }

};
